export const menu = {
  menu: {
    menu: "Menu",
    challenges: "Challenges",
    subscription: "Subskrypcja",
    cancelSubscription: "Anuluj subskrypcję",
    downloadPlanPdf: "Pobierz plan w PDF",
    downloadingPlanPdf: "Pobieranie...",
    editPlan: "Edytuj plan",
    shareBibleJourney: "Podziel się BibleJourneyem",
    giveFeedback: "Przekaż uwagi",
    donate: "Wesprzyj",
    logout: "Wyloguj",
    editReminder: "Edytuj przypomnienie",
    configureReminder: "Skonfiguruj przypomnienie",
    yourPlan: "Twój plan",
    challengeInvite: "Zaproszenie do wyzwania:",
    createAChallenge: "Utwórz wyzwanie",
    areYouSure: "Czy na pewno?",
    willLostProgress:
      "Utracisz dostęp do wszystkich utworzonych wyzwań i uczestników.",
    yesCancel: "Tak, anuluj subskrypcję",
    changedMyMind: "Zmieniłem zdanie",
    unsubscribing: "Anulowanie...",
    successfullyUnsubscribed: "Subskrypcja anulowana",
    premiumAccount: "Konto Premium",
    language: "Język",
    reminder: "Przypomnienie",
    theme: "Motyw",
    dark: "Ciemny",
    light: "Jasny",
    toCancel:
      "Aby anulować subskrypcję, przejdź w telefonie do Ustawień > Subskrypcje.",
    toCancelAndroid:
      "Aby anulować subskrypcję, wejdź do Google Play > profil > Płatności i subskrypcje > Subskrypcje.",
    processStarted: "Proces rozpoczęty",
    dangerArea: "Strefa zagrożenia",
    weWillGetInTouch:
      "Skontaktujemy się z Tobą i poinformujemy o postępie usuwania konta. Jeśli jesteś pewien, potwierdź:",
    payAttention: "Sprawdź skrzynkę odbiorczą. Wyślemy e-mail na",
    yesImSure: "Tak, jestem pewien.",
    askAccountRemoval: "Poproś o usunięcie konta",
  },
};
